import { Link } from "@/lib/router-compat";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSEO } from "@/hooks/useSEO";

export default function RefundPolicyPage() {
  const { t } = useTranslation();

  useSEO({
    title: t("refundPage.seoTitle"),
    description: t("refundPage.seoDescription"),
    noIndex: false,
  });

  return (
    <div className="container mx-auto px-6 py-12 max-w-3xl">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors">
        <ArrowLeft className="w-4 h-4" />
        {t("refundPage.backToHome")}
      </Link>

      <h1 className="text-3xl font-serif font-bold mb-2">{t("refundPage.title")}</h1>
      <p className="text-sm text-muted-foreground mb-10">{t("refundPage.lastUpdated")}</p>

      <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.introTitle")}</h2>
          <p>{t("refundPage.introContent")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.eligibilityTitle")}</h2>
          <p>{t("refundPage.eligibilityContent")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.howTitle")}</h2>
          <p>{t("refundPage.howContent")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.conditionsTitle")}</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>{t("refundPage.condition1")}</li>
            <li>{t("refundPage.condition2")}</li>
            <li>{t("refundPage.condition3")}</li>
            <li>{t("refundPage.condition4")}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.afterTitle")}</h2>
          <p>{t("refundPage.afterContent")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-foreground mb-3">{t("refundPage.contactTitle")}</h2>
          <p className="mb-3">{t("refundPage.contactContent")}</p>
          <div className="flex gap-4">
            <Link to="/terms" className="text-primary hover:underline">{t("refundPage.termsLink")}</Link>
            <Link to="/privacy" className="text-primary hover:underline">{t("refundPage.privacyLink")}</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
